import { useToast } from '@/components/ToastProvider';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';

import { useBackendRollout, useSetBackendRollout } from './useBackendRollout';

// Where new users who are not staff start: Python while off, TypeScript while
// on. Users who exist keep their backend, and staff start on TypeScript
// either way. The backend posts each change to the admin audit channel
export function NewUserBackendSwitch() {
  const { data, isLoading, error } = useBackendRollout();
  const setRollout = useSetBackendRollout();
  const toast = useToast();

  const onTypeScript = data?.new_users_start_on_typescript ?? false;

  const handleChange = async (next: boolean) => {
    const target = next ? 'TypeScript' : 'Python';
    const ok = window.confirm(
      `Start new users on ${target}?\n\n` +
        'Users who already exist keep the backend they are on.'
    );
    if (!ok) return;
    try {
      await setRollout.mutateAsync(next);
      toast.success(`New users now start on ${target}`);
    } catch (e) {
      toast.error(
        'Could not change where new users start',
        e instanceof Error ? e.message : 'Unknown error'
      );
    }
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between gap-4 space-y-0">
        <div className="space-y-1.5">
          <CardTitle className="text-base">
            New users start on TypeScript
          </CardTitle>
          <CardDescription>
            New users who are not staff start on TypeScript while this is on.
            Turning it on or off moves no existing user.
          </CardDescription>
          {error && <p className="text-sm text-destructive">{error.message}</p>}
        </div>
        <Switch
          checked={onTypeScript}
          disabled={isLoading || Boolean(error) || setRollout.isPending}
          onCheckedChange={(next) => void handleChange(next)}
          aria-label="New users start on TypeScript"
        />
      </CardHeader>
    </Card>
  );
}
